(() => {
  const storageKey = 'ridzna-color-mode';
  const root = document.documentElement;

  const isLight = () => root.dataset.ridznaTheme === 'light';

  const syncControls = () => {
    const light = isLight();
    const label = light ? 'Switch to dark mode' : 'Switch to light mode';

    document.querySelectorAll('[data-ridzna-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      button.setAttribute('aria-pressed', String(light));
    });

    document.querySelector('[data-ridzna-theme-color]')?.setAttribute('content', light ? '#ffffff' : '#080806');
  };

  const toggleMode = () => {
    const nextMode = isLight() ? 'dark' : 'light';

    if (nextMode === 'light') {
      root.dataset.ridznaTheme = 'light';
    } else {
      delete root.dataset.ridznaTheme;
    }

    try {
      localStorage.setItem(storageKey, nextMode);
    } catch (error) {
      // The visual toggle still works when storage is unavailable.
    }

    syncControls();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ridzna-theme-toggle]')) toggleMode();
  });

  document.addEventListener('shopify:section:load', syncControls);
  syncControls();
})();
